import { useLearnerInfo } from "@/api/services/main/learner";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { LearnerDetailPage } from "@/features/learner/components/LearnerDetail";
import { convertResToFormData } from "@/features/learner/utils/convertLearnerFormData";
import { useValidateId } from "@/hooks/useValidateId";
import { AppRoutes } from "@/routes/config";

const LearnerDetail = () => {
  const queryResult = useLearnerInfo();
  const { data, isLoading } = queryResult;
  useValidateId("learnerId", AppRoutes.learnerList, queryResult);

  if (!data || isLoading) return <LoadingPage />;
  return <LearnerDetailPage data={convertResToFormData(data.data)} />;
};

export default LearnerDetail;
